import { CaseSchema, DefaultCaseSchema } from '@feedyou/schema'

import { prompt } from '../../../lib/bootbox'
import { sanitizeText } from '../../../lib/sanitizeText'

export async function getCondition(
  title: string | undefined,
  value: string
): Promise<{ title: string; expression: string } | undefined> {
  const promptTitle = await prompt({ title: "What's the title?", value: title })

  if (promptTitle === null) {
    return
  }

  const promptValue = await prompt({
    title: "What's the expression",
    value
  })

  if (promptValue === null) {
    return
  }

  return { expression: promptValue, title: promptTitle }
}

export const sanitizeTitle = (obj: { title?: string | null }) => {
  // Make sure not to add a `title: undefined` when the property is not present on input obj
  if (!obj.title) {
    return obj
  }

  return { ...obj, title: sanitizeText(obj.title) }
}

export function getCaseText(caseOrDefault: CaseSchema | DefaultCaseSchema, isDefault: boolean) {
  const fallback = isDefault ? 'Default' : 'Empty value'
  return caseOrDefault.title || caseOrDefault.value || fallback
}
